import { Injectable } from "@angular/core"
import { Http } from "@angular/http"
import { Observable } from 'rxjs/Observable';

import { HttpHelperService } from './helpers/http-helper.service';

@Injectable()

export class ContactService {
    constructor(
        private http: Http,
        private httpHelperService: HttpHelperService
    ) { }

    contactForm(formData) {
        return new Promise((resolve, reject) => {
            const body = formData;
            this.http.post('/api/contactform', body, { headers: this.httpHelperService.headers(false) }).subscribe((res: any) => {
                var result = res.json()
                if (result) {
                    resolve(result)
                } else {
                    reject(result)
                }
            }, (err: any) => {
                reject(err);
            })
        })
    }

    handleErrors(error: Response) {
        return Observable.throw(error);
    }
}


// WEBPACK FOOTER //
// ./src/app/services/contact.service.ts